import { useImageStatusStore } from '@stores/useImageStatusStore'

export function useImageStatus() {
  const isHighlightedImage = useImageStatusStore(
    (state) => state.isHighlightedImage,
  )
  const setIsHighlightedImage = useImageStatusStore(
    (state) => state.setIsHighlightedImage,
  )
  const isExpanded = useImageStatusStore((state) => state.isExpanded)
  const setIsExpanded = useImageStatusStore((state) => state.setIsExpanded)
  const expandedHeight = useImageStatusStore((state) => state.expandedHeight)
  const setExpandedHeight = useImageStatusStore(
    (state) => state.setExpandedHeight,
  )
  const reset = useImageStatusStore((state) => state.reset)

  return {
    isHighlightedImage,
    setIsHighlightedImage,
    isExpanded,
    setIsExpanded,
    expandedHeight,
    setExpandedHeight,
    reset,
  }
}
